module.exports = __webpack_public_path__ + "static/media/halloween9.f5987189.jpg";